
export namespace DashboardNs {

  export enum DashboardRouteEnums {
    DASHBOARD = 'Dashboard',
    PROJECTS = 'DashboardProjects',
    TRASH = 'DashboardTrash'
  }

  export interface Notification {
    name: string,
    data: NotificationItem[]
  }

  export interface NotificationItem {
    img?: string,
    name?: string,
    text: string,
    project: string,
    time: string,
  }

  export interface MemberListInterface {
    name: string,
    image?: string,
    avatar?: string
  }

}
